// extracted by mini-css-extract-plugin
export var infoItem = "_qt-2";
export var title = "_qt-0";
export var value = "_qt-1";